import { BarChart3, Building2, Calculator, Sprout, Users } from "lucide-react";

export const services = [
  {
    slug: "company-formation",
    name: "Company Formation",
    short: "Company formation",
    audience: "businesses",
    icon: Building2,
    color: "var(--blue)",
    soft: "var(--blue-soft)",
    pitch: "The right entity in the right place, registered and ready to trade.",
    lede: "We set up companies, branches and subsidiaries across India, the Middle East and Africa, then keep them in good standing with every registry and authority.",
    who: ["Founders", "Expanding groups", "Investors"],
    covers: [
      { title: "Entity set-up", desc: "Private companies, branches, subsidiaries and holding companies, structured for how you plan to operate." },
      { title: "Licences and registrations", desc: "Trade and business licences, tax registrations and the approvals each activity needs." },
      { title: "Company secretarial", desc: "Statutory registers, board and shareholder minutes, and annual returns filed on time." },
      { title: "Bank account opening", desc: "We prepare the documents banks ask for and support you through onboarding." },
      { title: "Ownership and compliance filings", desc: "Beneficial-ownership registers and recurring filings kept current." },
      { title: "Restructuring and closures", desc: "Share transfers, re-domiciliations, mergers and voluntary closures." },
    ],
  },
  {
    slug: "accounting-taxation",
    name: "Accounting & Taxation",
    short: "Accounting & taxation",
    audience: "businesses",
    icon: Calculator,
    color: "var(--emerald)",
    soft: "var(--emerald-soft)",
    pitch: "Clean books every month and tax returns filed on time, in every country you operate.",
    lede: "Bookkeeping, financial statements and tax compliance handled by one team, with local filing calendars tracked for each entity.",
    who: ["SMEs", "Multi-country groups", "Holding companies"],
    covers: [
      { title: "Bookkeeping", desc: "Monthly books on cloud accounting systems, reconciled and ready for review." },
      { title: "Financial statements and audit support", desc: "Annual accounts prepared to the required standard, with audit coordination." },
      { title: "Corporate tax", desc: "Registration, computations and annual returns for each entity." },
      { title: "Indirect tax", desc: "VAT and GST registration and periodic returns where they apply." },
      { title: "Withholding and payroll taxes", desc: "Deductions, deposits and returns calculated and filed on schedule." },
      { title: "Transfer pricing", desc: "Documentation and policies for transactions between group companies." },
    ],
  },
  {
    slug: "hr-payroll",
    name: "HR & Payroll",
    short: "HR & payroll",
    audience: "businesses",
    icon: Users,
    color: "var(--saffron-ink)",
    soft: "var(--saffron-soft)",
    pitch: "Hire, pay and look after your people correctly in every country.",
    lede: "Payroll, employment documents and HR compliance for teams spread across several countries, run to each country's labour rules.",
    who: ["Growing teams", "New market entrants", "Groups with staff in several countries"],
    covers: [
      { title: "Payroll processing", desc: "Monthly payroll with payslips, statutory deductions and payment files." },
      { title: "Employment contracts and policies", desc: "Contracts, handbooks and HR policies aligned to local labour law." },
      { title: "Work permits and onboarding", desc: "Coordination of work permits, visas and onboarding paperwork." },
      { title: "Statutory benefits and end-of-service", desc: "Leave, gratuity and end-of-service calculations and filings." },
      { title: "HR compliance reviews", desc: "A check of your HR documents and practices against local rules." },
      { title: "HR outsourcing", desc: "A day-to-day HR function for teams without their own HR staff." },
    ],
  },
  {
    slug: "cfo-services",
    name: "CFO Services",
    short: "CFO services",
    audience: "businesses",
    icon: BarChart3,
    color: "var(--ink)",
    soft: "var(--tint)",
    pitch: "Senior finance leadership when you need it, without a full-time hire.",
    lede: "A fractional CFO and finance team that turns your numbers into decisions: reporting, planning, cash and fundraising.",
    who: ["Founder-led businesses", "Investor-backed companies", "Family businesses"],
    covers: [
      { title: "Fractional CFO", desc: "A senior finance lead working with you on a part-time or project basis." },
      { title: "MIS and board reporting", desc: "Monthly management packs with the numbers your board needs." },
      { title: "Budgeting and forecasting", desc: "Annual budgets, rolling forecasts and scenario models." },
      { title: "Cash flow and treasury", desc: "Cash planning, working capital and banking relationships." },
      { title: "Fundraising and investor readiness", desc: "Financial models, data rooms and investor materials." },
      { title: "Due diligence and deal support", desc: "Financial due diligence and support through acquisitions and investments." },
    ],
  },
  {
    slug: "private-wealth-family-office",
    name: "Private Wealth & Family Office",
    short: "Private wealth & family office",
    audience: "families",
    icon: Sprout,
    color: "var(--coral)",
    soft: "var(--coral-soft)",
    pitch: "Protect what you have built and plan for the next generation.",
    lede: "Structuring, governance and reporting for families and their businesses, from a first holding structure to a full family office.",
    who: ["Business-owning families", "Individuals with assets in several countries", "Family offices"],
    covers: [
      { title: "Family office set-up", desc: "Single-family office design, set-up and day-to-day operation." },
      { title: "Holding and succession structures", desc: "Holding companies, foundations and trusts planned around succession." },
      { title: "Family governance", desc: "Family charters, councils and decision rules agreed in writing." },
      { title: "Consolidated wealth reporting", desc: "One view of assets held across countries and entities." },
      { title: "Real estate holding", desc: "Ownership and administration structures for property portfolios." },
      { title: "Philanthropy", desc: "Charitable vehicles and giving programmes with proper governance." },
    ],
  },
];

export const businessServices = services.filter((s) => s.audience === "businesses");
export const familyServices = services.filter((s) => s.audience === "families");

export const regionDots = ["var(--coral)", "var(--saffron)", "var(--emerald)"];
